import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { FlatButton, TransparentFlatButton } from '@ui/buttons';
import { runningLabel } from './copy';

// What a read is doing right now: failing, or taking its ~24 seconds.
//
// Raw JSX in a 1077-line page, which meant a redesign standardising loading and error treatment had
// to find it by reading the page. It also carried an unnamed UX decision in a template literal —
// acknowledging a RE-READ differently from a first read, because the table below is still the old
// one and "again" is the word that stops it reading as a page that has not moved. That wording is a
// constant in copy.js now, and this is where it renders.

const ErrorPanel = styled.div`
  border: 1px solid ${({ theme }) => theme.themeColors.error};
  border-radius: 6px;
  padding: 12px;
`;

export const FeedRunStatus = ({ isRunning, hasResult, error, retryable, onRetry, onCancel }) => (
  <>
    {error && (
      <Container top={16}>
        <ErrorPanel role="alert">
          <Body5>{error}</Body5>
          {retryable && (
            <Container top={12}>
              <FlatButton onClick={onRetry}>Try again</FlatButton>
            </Container>
          )}
        </ErrorPanel>
      </Container>
    )}

    {/* Shown on every run, including one that already has a table on screen — otherwise a slow
        re-read looks like nothing is happening. */}
    {isRunning && (
      <Container top={16} row verticallyCenter>
        <Body5 isLowContrast role="status">
          {runningLabel(hasResult)}
        </Body5>
        <Container left={12}>
          <TransparentFlatButton onClick={onCancel}>Cancel</TransparentFlatButton>
        </Container>
      </Container>
    )}
  </>
);
